<template>
  <div class="App-Form-Title">
    <h3 txt-center>{{ title || "Provide title" }}</h3>
    <p txt-center>
      <slot></slot>
    </p>
  </div>
</template>

<script>
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    title: String,
  },
  components: {},

})
export default class extends Vue {}
</script>

<style lang="scss">
.App-Form-Title {
  h3 {
    margin: 4px;
  }
  max-width: 300px;
  margin: auto;
  p {
    color: var(--el-text-color-regular);
    font-size: var(--el-font-size-small);
    margin: 2px;
  }
}
</style>
